import React from "react";
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import FormHeader from "../form/FormHeader";
import FormText from "../form/FormText";
import FormRemark from "../form/FormRemark";
import StepNavBar from "./StepNavBar";
import Divider from "../core/Divider";
import Container2 from "../common/Container2";
import Space from "../core/Space";
import ShadowBox from "../core/ShadowBox";
import FormTitle from "../form/FormTitle";
import FormButtonSecondary from "../form/FormButtonSecondary";
import FormButtonDanger from "../form/FormButtonDanger";
import useApplyNewStore from "../../store/useApplyNewStore";
import useViewStore from "../../store/useViewStore";
import useAuthStore from "../../store/useAuthStore";
import Flex from "../core/Flex";
import { basename } from "../../setting";

function StepPaymentFail() {
  const { t } = useTranslation();
  const { isMobileView } = useViewStore((state) => state);
  const navigate = useNavigate();
  const { step, setStep, refno, getPreAuthFormData } = useApplyNewStore();

  const goBack = () => {
    // setStep("0");
    navigate(`/${basename}`);
  };

  return (
    <Container2 style={{ marginBottom: 64 }}>
      <FormHeader>{t("translation:apply.paymentFail.title")}</FormHeader>
      <FormText>{t("translation:apply.paymentFail.subtitle1", { key: getPreAuthFormData.user.userName })}</FormText>
      <Space height={8} />
      <FormText bold={true} style={{ fontWeight: "bold" }}>{t("translation:apply.paymentFail.subtitle2")}</FormText>

      <Space height={24} />

      <Flex gap={10} direction={isMobileView ? "column" : "row"}>
        <FormButtonDanger style={isMobileView ? { width: "100%" } : {}} onClick={() => { setStep("4"); }}>{t("tryAgain")}</FormButtonDanger>
        <FormButtonSecondary style={isMobileView ? { width: "100%" } : {}} onClick={goBack}>{t("backToHome")}</FormButtonSecondary>
      </Flex>

      <Space height={24} />

      <FormRemark>{t("refno")}： {refno}</FormRemark>

      <Space height={32} />

      <FormTitle style={{ fontSize: 18 }}>{t("translation:apply.paymentFail.contactUs")}</FormTitle>
      <Space height={16} />

      <Flex direction={"column"} alignItems={"flex-start"}>
        <Flex>
          <Icon src={`${process.env.PUBLIC_URL}/images/email.svg`} alt="email" />
          <FormTitle>mcuser@bluecross.com.hk</FormTitle>
        </Flex>
        <Flex>
          <Icon src={`${process.env.PUBLIC_URL}/images/mobile.svg`} alt="phone" />
          <FormTitle>2839 6333</FormTitle>
        </Flex>
      </Flex>
    </Container2>
  );
}

const ShadowBoxContainer = styled.div`
  width: 300px;
  margin: 10px 0;
`;

const RefNo = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

export default StepPaymentFail;